module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/voice-avatar-02-6cfd3d6c869ebb8b35fa63f86a91a6f4.png";